export default {"src":"/_next/static/media/glazier-lockup-white.09d057d1.svg","height":198,"width":1078,"blurWidth":0,"blurHeight":0};